import { render, staticRenderFns } from "./GestionServices.vue?vue&type=template&id=3c93b7b5&scoped=true&"
import script from "./GestionServices.vue?vue&type=script&lang=js&"
export * from "./GestionServices.vue?vue&type=script&lang=js&"
import style0 from "./GestionServices.vue?vue&type=style&index=0&id=3c93b7b5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c93b7b5",
  null
  
)

export default component.exports